import React from "react";
import {useNavigate} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {WithOrganization} from "../components/organizations/organization-context";
import {
    StyleGuestAssignmentEditor
} from "../components/pro-guest/shared/guests/GuestAssignmentEditor";
import ReactsCard from "../components/ui/ReactsCard";
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(4),
        '& > *': {
            'margin-bottom': theme.spacing(4)
        }
    },
    top: {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center'
    }
}));

export const MyGuestsAdd: React.FC<WithOrganization> = ({currentOrganization}) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const title = 'MyGuests.ProviderAddGuestHeader';
    const {t} = useTranslation();

    const goBack = () => {
        navigate(`/my-guests`);
    };

    return (
        <div className={classes.root}>
            <ReactsCard title={t(title)}>
                <StyleGuestAssignmentEditor
                    organizationId={currentOrganization.id}
                    onCancel={() => goBack()}
                    onDone={() => goBack()}
                />
            </ReactsCard>
        </div>
    )
};
